import { Pipe, PipeTransform } from '@angular/core';
/**
 * Retourne le nom de l'usager
 */
@Pipe({
  name: 'getUserName',
})
export class UserNamePipe implements PipeTransform {
  transform(key: any, userList: any): string {
    // chercher le nom si la liste n'est pas vide
    if (userList) {
      let name = userList
        .filter((c: any) => c.id == key)
        .map((c: any) => {
          return c.userFullName;
        });

      if (name && name.length > 0) {
        return name[0];
      }
    }
    // on retourne le key si on ne trouve pas le nom
    return key;
  }
}
